$(document).ready(function() {
	$(".b-materials__show-more--themes").on('click', (e) => {
		console.log(1)
		$(".b-themes__list--themes").toggleClass("open");
		if($(".b-themes__list--themes").hasClass("open")) {
			$(".b-materials__show-more--themes").text("Свернуть");
		} else {
			$(".b-materials__show-more--themes").text("Показать все");
		}
	});
	$(".b-materials__show-more--materials").on('click', (e) => {
		console.log(2)
		$(".b-materials__list--materials").toggleClass("open");
		if($(".b-materials__list--materials").hasClass("open")) {
			$(".b-materials__show-more--materials").text("Свернуть");
		} else {
			$(".b-materials__show-more--materials").text("Показать все");
		}
	});
});




// WEBPACK FOOTER //
// ./src/js/pages/search-page/search-page.js